// Shared constants for Training Program placement.
// Mirrors backend TRAINING_LEVELS / TRAINING_SUB_TIERS.

export const TRAINING_LEVELS = ["Maximize", "The Program Platinum", "Workouts", "WME NIL"];

export const TRAINING_SUB_TIERS = ["Mentorship", "YL Tier 1", "YL Tier 2", "YL Custom"];

// Dashboard render order + section metadata
export const TRAINING_SECTIONS = [
  {
    key: "Maximize",
    label: "Maximize Clients",
    accent: "#d8b854",
    description: "Full year-long development — Mentorship + YL tiers",
  },
  {
    key: "The Program Platinum",
    label: "The Program Platinum",
    accent: "#c084fc",
    description: "Program Platinum athletes",
  },
  {
    key: "Workouts",
    label: "Workouts",
    accent: "#60a5fa",
    description: "Workout-based tracking",
  },
  {
    key: "WME NIL",
    label: "WME NIL",
    accent: "#2dd4bf",
    description: "WME agency college NIL clients — followed, not Maximize clients",
  },
  {
    key: "__UNASSIGNED__",
    label: "Unassigned",
    accent: "#575757",
    description: "No training placement yet",
  },
];

export const TRAINING_LEVEL_ACCENT = TRAINING_SECTIONS.reduce((acc, s) => {
  acc[s.key] = s.accent;
  return acc;
}, {});

export function trainingLabel(level, subTier, { compact = false } = {}) {
  if (!level) return "Unassigned";
  if (level === "Maximize") {
    if (!subTier) return "Maximize";
    return compact ? subTier : `Maximize · ${subTier}`;
  }
  return level;
}
